<script>
  import ImprimirBoleto from '../../financeiro/components/ImprimirBoleto'

  import * as restfulService from '../../../services/restfulService'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'
  import {mapGetters} from 'vuex'

  export default {
    mixins: [helpers],
    name: 'dashboard-pre-matriculado-popup',
    components: {ImprimirBoleto},
    data () {
      return {
        mostrarModal: false,
        mostrarModalPdf: false,
        pdfBase64: '',
        primeiroTitulo: null,
        tipo: null
      }
    },
    mounted () {
      this.buscarPopup()
    },
    computed: {
      ...mapGetters(['currentUser', 'isLogged']),
      isMobileSize: function () {
        return this.isMobile().any()
      },
      primeiroNome: function () {
        if (this.isLogged) {
          let nome = (this.currentUser.pessoa.nome.split(' ')[0] || '').toLowerCase()
          return nome.charAt(0).toUpperCase() + nome.slice(1)
        }
        return ''
      }
    },
    methods: {
      buscarPopup () {
        restfulService.get('dashboard', 'popup-pre-matriculado')
          .then(response => {
            if (response.pre_matriculado) {
              this.mostrarModal = true
              this.primeiroTitulo = response.primeiro_titulo
              this.tipo = response.tipo
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      imprimirPdf (item) {
        bus.$emit('show-loader')
        restfulService.get('boleto', 'pdf', item.id)
          .then((response) => {
            this.pdfBase64 = 'data:application/pdf;base64,' + response.base64
            this.mostrarModalPdf = true
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div>
        <v-dialog v-model="mostrarModal"
                  :width="isMobileSize ? '90%' : '40%'"
                  persistent>
            <v-card class="popup-modal">
                <v-container v-if="tipo=='preMatricula'">
                    <h3 class="pb-3" :class="{'display-0': isMobileSize, 'display-1': !isMobileSize}">
                        Pré-matriculado
                    </h3>
                    <div class="text">
                        <p :class="{'body-1': isMobileSize, 'subheading': !isMobileSize}">
                            Olá <strong>{{primeiroNome}}</strong>, sua situação acadêmica ainda consta como
                            pré-matriculado. Para confirmar sua matrícula, efetive o pagamento do 1º boleto.
                            <template v-if="primeiroTitulo">
                                <imprimir-boleto :titulo="primeiroTitulo"
                                                 descricao-link="Clique aqui para imprimir o boleto"
                                                 class="d-inline-block"/>.
                            </template>
                            <br><br>
                            * Caso já tenha efetuado o pagamento, o mesmo pode levar até três dias úteis para
                            confirmação.
                            Se ainda
                            assim persistir a mensagem, entre em contato com a Central de Atendimento para maiores
                            informações.
                        </p>
                    </div>
                </v-container>
                <v-container v-if="tipo=='intencaoMatricula'">
                    <h3 class="pb-3" :class="{'display-0': isMobileSize, 'display-1': !isMobileSize}">
                        Intenção de Matrícula
                    </h3>
                    <div class="text">
                        <p :class="{'body-1': isMobileSize, 'subheading': !isMobileSize}">
                            Olá <strong>{{primeiroNome}}</strong>, sua situação acadêmica ainda consta como
                            pré-matriculado em curso com intenção de matrícula. Para confirmar seu interesse, efetive o pagamento do boleto.
                            <template v-if="primeiroTitulo">
                                <imprimir-boleto :titulo="primeiroTitulo"
                                                 descricao-link="Clique aqui para imprimir o boleto"
                                                 class="d-inline-block"/>.
                            </template>
                            <br><br>
                            * Caso já tenha efetuado o pagamento, o mesmo pode levar até três dias úteis para
                            confirmação.
                            Se ainda
                            assim persistir a mensagem, entre em contato com a Central de Atendimento para maiores
                            informações.
                        </p>
                    </div>
                </v-container>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="mostrarModal = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>



// WEBPACK FOOTER //
// PreMatriculadoPopup.vue?8d1c2b0a